import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { MAX_OUTPUT_EDGE, MIN_OUTPUT_EDGE } from '../../../../config';

import scss from './CustomSize.module.scss';

const toEdge = (value) => Math.round(Number(value));
const isValidEdge = (value) => Number.isFinite(value) && value >= MIN_OUTPUT_EDGE && value <= MAX_OUTPUT_EDGE;

function CustomSize({ outputSize, active, onApply }) {
  const { t } = useTranslation('mediaStudio');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');

  useEffect(() => {
    if (outputSize?.width && outputSize?.height) {
      setWidth(String(Math.round(outputSize.width)));
      setHeight(String(Math.round(outputSize.height)));
    }
  }, [outputSize?.width, outputSize?.height]);

  const w = toEdge(width);
  const h = toEdge(height);
  const valid = isValidEdge(w) && isValidEdge(h);

  const submit = (event) => {
    event.preventDefault();
    if (valid) {
      onApply(w, h);
    }
  };

  return (
    <form className={clsx(scss.customSize, active && scss.customSizeActive)} onSubmit={submit}>
      <div className={scss.sizeFields}>
        <label className={scss.sizeField}>
          <span className={scss.sizeLabel}>{t('formatWidthShort')}</span>
          <span className={scss.sizeInput}>
            <input
              type='number'
              inputMode='numeric'
              min={MIN_OUTPUT_EDGE}
              max={MAX_OUTPUT_EDGE}
              value={width}
              aria-label={t('formatWidth')}
              onChange={(event) => setWidth(event.target.value)}
            />
            <span>px</span>
          </span>
        </label>
        <span className={scss.sizeTimes}>×</span>
        <label className={scss.sizeField}>
          <span className={scss.sizeLabel}>{t('formatHeightShort')}</span>
          <span className={scss.sizeInput}>
            <input
              type='number'
              inputMode='numeric'
              min={MIN_OUTPUT_EDGE}
              max={MAX_OUTPUT_EDGE}
              value={height}
              aria-label={t('formatHeight')}
              onChange={(event) => setHeight(event.target.value)}
            />
            <span>px</span>
          </span>
        </label>
      </div>
      <button type='submit' className={scss.sizeApply} disabled={!valid}>
        {t('formatApplySize')}
      </button>
    </form>
  );
}

export default CustomSize;
